import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';

// onLoaded -> callback for child when its done loading
const SequentialLoadingList = ({ lazyLoad = false, height, children = [] }) => {
  const [index, setIndex] = useState(0);

  if (lazyLoad) {
    return (
      <>
        {children.map((child, i) => (
          <LazyLoad offset={100} height={height} once key={child.key}>
            {React.cloneElement(child, { onLoaded: () => setIndex(Math.max(index, i + 1)), canLoad: index >= i })}
          </LazyLoad>
        ))}
      </>
    );
  }

  return (
    <>{children.map((child, i) => React.cloneElement(child, { onLoaded: () => setIndex(Math.max(index, i + 1)), canLoad: index >= i }))}</>
  );
};

export default SequentialLoadingList;
